import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'rosters-pages',
})

export default class RostersPages extends Vue {

    // ---------------------------------------------------------------------
    // Properties

    private eventBind: any = {
        onSelectRow: this.onSelectRow,
    };

    private dataBind: any = {
        orgData: null,
        schoolData: null,
        classData: null,
    };

    @Prop()
    private activeRouteObj: any;

    // Only purpose to watch the router changes
    @Watch('activeRouteObj', {deep: true})
    private onChangeRoute() {
       this.resetProperties();
    }


    // -----------------------------------------------------------------
    // Actions

    private onSelectRow(data: any, level: string) {
        this.$set(this.dataBind, level, data);
    }

    private resetProperties() {
        this.dataBind = {
            orgData: null,
            schoolData: null,
            classData: null,
        };
    }

}
